/** @type {import('next').NextConfig} */
// module.exports = {
//   i18n: {
//     localeDetection: false,
//     // These are all the locales you want to support in
//     // your application
//     locales: ['de', 'en'],
//     // This is the default locale you want to be used when visiting
//     // a non-locale prefixed path e.g. `/hello`
//     defaultLocale: 'de',
//     // This is a list of locale domains and the default locale they
//     // should handle (these are only required when setting up domain routing)
//     // Note: subdomains must be included in the domain value to be matched e.g. "fr.example.com".
//     // domains: [
//     //   {
//     //     domain: DOMAIN + '.com',
//     //     defaultLocale: 'en-US',
//     //     // TODO: remove in production
//     //     http: IS_HTTP,
//     //   },
//     //   {
//     //     domain: DOMAIN + '.de',
//     //     defaultLocale: 'de',
//     //     // TODO: remove in production
//     //     http: IS_HTTP,
//     //   },
//     // ],
//   },
//
//   //Todo: Make namnespace for header and footer and all data that is loaded on everypage
//   //defaultNS:'contact',
//   localePath:
//     typeof window === 'undefined'
//       ? require('path').resolve('./public/locales')
//       : '/locales',
//   reloadOnPrerender: process.env.NODE_ENV === 'development',
// }

import path from 'path'

export default {
  i18n: {
    localeDetection: false,
    // These are all the locales you want to support in
    // your application
    locales: ['de', 'en'],
    // This is the default locale you want to be used when visiting
    // a non-locale prefixed path e.g. `/hello`
    defaultLocale: 'de',
    // This is a list of locale domains and the default locale they
    // should handle (these are only required when setting up domain routing)
    // Note: subdomains must be included in the domain value to be matched e.g. "fr.example.com".
    // domains: [
    //   {
    //     domain: DOMAIN + '.com',
    //     defaultLocale: 'en-US',
    //     // TODO: remove in production
    //     http: IS_HTTP,
    //   },
    //   {
    //     domain: DOMAIN + '.de',
    //     defaultLocale: 'de',
    //     // TODO: remove in production
    //     http: IS_HTTP,
    //   },
    // ],
  },

  //Todo: Make namnespace for header and footer and all data that is loaded on everypage
  //defaultNS:'contact',
  localePath:
    typeof window === 'undefined'
      ? path.resolve('./public/locales')
      : '/locales',
  reloadOnPrerender: process.env.NODE_ENV === 'development',
}
